export default __webpack_public_path__ + "static/media/steve.27401739.png";